export const NewAttachments = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 14"
    fill="none"
  >
    <g clipPath="url(#clip0_2730_14836)">
      <path
        d="M4.18916 1.08302L9.37197 2.83808C10.1293 3.06868 10.6936 3.63548 10.9596 4.329C10.5378 4.14255 10.0728 4.03669 9.5833 4.03211L4.58402 3.98534C2.65411 3.96729 1.06948 5.52303 1.05143 7.45244L1.04364 8.28491C0.239929 7.66286 -0.144464 6.58072 0.179653 5.55421L1.07921 2.7195C1.49138 1.4213 2.8863 0.687314 4.18916 1.08302ZM4.57467 4.9853L9.57445 5.03207C10.9529 5.04497 12.0638 6.17691 12.051 7.55535L12.0229 10.5552C12.01 11.9337 10.878 13.0446 9.49961 13.0317L4.49983 12.9849C3.12139 12.9721 2.01043 11.8401 2.02332 10.4617L2.05139 7.4618C2.06429 6.08336 3.19623 4.9724 4.57467 4.9853Z"
        fill="#CFCDD6"
      />
    </g>
    <defs>
      <clipPath id="clip0_2730_14836">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 12.9438) rotate(-89.464)"
        />
      </clipPath>
    </defs>
  </svg>
);
